export default "__VITE_ASSET__DGozM7Cq__"